import React, { useEffect, useState } from 'react';
import InvoiceEditModal from './InvoiceEditModal';
import FacturaModal from './FacturaModal';
import * as smartbillSvc from '../../services/smartbill';

const STATUS_COLORS = {
  neplatita:         { bg: '#fef3c7', color: '#92400e' },
  platita:           { bg: '#d1fae5', color: '#065f46' },
  anulata:           { bg: '#f3f4f6', color: '#6b7280' },
  stornata:          { bg: '#fee2e2', color: '#991b1b' },
  facturata:         { bg: '#dbeafe', color: '#1d4ed8' },
  facturata_partial: { bg: '#ede9fe', color: '#6d28d9' },
  depasita:          { bg: '#fce7f3', color: '#9d174d' },
  incasata_partial:  { bg: '#ede9fe', color: '#6d28d9' },
};

const STATUS_LABELS = {
  neplatita:         'Neplatita',
  platita:           'Platita',
  anulata:           'Anulata',
  stornata:          'Stornata',
  facturata:         'Facturata',
  facturata_partial: 'Fact. partial',
  depasita:          'Depasita',
  incasata_partial:  'Incasat partial',
};

function getStatusLabel(status, tip) {
  if (tip === 'fiscala' && status === 'platita') return 'Incasata';
  return STATUS_LABELS[status] || status;
}

function fmtDate(d) {
  if (!d) return '—';
  const [y, m, z] = d.split('-');
  return `${z}.${m}.${y}`;
}

function fmtMoney(v, moneda) {
  if (v == null) return '—';
  return `${Number(v).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${moneda || 'RON'}`;
}

export default function FacturiAsociate({ procId, clientId, showToast }) {
  const [docs, setDocs]               = useState([]);
  const [loading, setLoading]         = useState(true);
  const [editDoc, setEditDoc]         = useState(null);
  const [convertDoc, setConvertDoc]   = useState(null);
  const [reEditDoc, setReEditDoc]     = useState(null);

  useEffect(() => {
    if (!procId || !clientId) { setLoading(false); return; }
    setLoading(true);
    smartbillSvc.getDocuments(clientId, { procedura_id: procId })
      .then(r => setDocs(r.data?.documente || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [procId, clientId]);

  const patchDoc = (updated) => setDocs(ds => ds.map(d => d.id === updated.id ? updated : d));
  const addDoc   = (doc)     => setDocs(ds => [doc, ...ds]);

  if (loading) return null;
  if (!docs.length) return null;

  return (
    <>
      <div className="tr-card" style={{ marginTop: 12 }}>
        <div className="tr-card-head">
          <span className="tr-card-title">Facturi asociate</span>
          <span style={{ marginLeft: 8, background: '#e8ff73', color: '#101216', borderRadius: 99, fontSize: 10, fontWeight: 700, padding: '1px 7px' }}>
            {docs.length}
          </span>
        </div>
        <div className="tr-card-body" style={{ padding: '4px 0 0' }}>
          {docs.map(doc => {
            const st = doc.este_ciorna ? 'ciorna' : doc.status_plata;
            const stColor = STATUS_COLORS[st] || { bg: '#f3f4f6', color: '#6b7280' };
            const stLabel = doc.este_ciorna ? 'Ciorna' : getStatusLabel(doc.status_plata, doc.tip);
            const tipLabel = doc.tip === 'fiscala' ? 'Factura' : 'Proforma';
            const ref = doc.numar ? `${doc.serie || ''}${doc.numar}` : '(nedepusa)';
            return (
              <div
                key={doc.id}
                onClick={() => setEditDoc(doc)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  padding: '8px 12px',
                  borderRadius: 8,
                  cursor: 'pointer',
                  transition: 'background .12s',
                  marginBottom: 2,
                }}
                className="fa-row"
              >
                <div style={{ minWidth: 60, fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '.3px' }}>
                  {tipLabel}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 13, color: '#1a2540' }}>{ref}</div>
                  <div style={{ fontSize: 11, color: '#8a96ab', marginTop: 1 }}>{fmtDate(doc.data_emitere)}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontWeight: 700, fontSize: 13, color: '#1a2540' }}>{fmtMoney(doc.total, doc.moneda)}</div>
                  <span style={{ ...stColor, fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 99, display: 'inline-block', marginTop: 3 }}>
                    {stLabel}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {editDoc && (
        <InvoiceEditModal
          doc={editDoc}
          onClose={() => setEditDoc(null)}
          onSaved={updated => { patchDoc(updated); setEditDoc(null); }}
          onConverted={fiscala => { addDoc(fiscala); setEditDoc(null); }}
          onConvert={doc => { setConvertDoc(doc); setEditDoc(null); }}
          onReEdit={doc => { setReEditDoc(doc); setEditDoc(null); }}
          showToast={showToast}
        />
      )}

      {reEditDoc && (
        <FacturaModal
          client={{ id: reEditDoc.client_id }}
          editDoc={reEditDoc}
          onClose={() => setReEditDoc(null)}
          onSaved={doc => { addDoc(doc); setReEditDoc(null); }}
          showToast={showToast}
        />
      )}

      {convertDoc && (
        <FacturaModal
          client={{ id: convertDoc.client_id }}
          convertDoc={convertDoc}
          onClose={() => setConvertDoc(null)}
          onSaved={doc => { addDoc(doc); setConvertDoc(null); }}
          showToast={showToast}
        />
      )}
    </>
  );
}
